<template>
  <div :id="id">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'AnchorItem',
  inject: ['AnchorInstance'],
  props: {
    name: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    iconColor: {
      type: String,
      default: '#ccc'
    }
  },
  data() {
    return {};
  },
  watch: {
    name(val) {
      // this.currentName = val;
      this.updateAnchor();
    },
    id() {
      this.updateAnchor();
    },
    icon() {
      this.updateAnchor();
    },
    iconColor() {
      this.updateAnchor();
    }
  },
  mounted() {
    this.updateAnchor();
  },
  methods: {
    updateAnchor() {
      this.AnchorInstance.updateAnchor();
    }
  }
};
</script>
<style scoped>

</style>
